import { render, staticRenderFns } from "./OilCost.vue?vue&type=template&id=f6010c48&scoped=true&"
import script from "./OilCost.vue?vue&type=script&lang=js&"
export * from "./OilCost.vue?vue&type=script&lang=js&"
import style0 from "./OilCost.vue?vue&type=style&index=0&id=f6010c48&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6010c48",
  null
  
)

export default component.exports